import { Component, Vue, Watch as watch} from 'nuxt-property-decorator';
import {mapGetters} from 'vuex';
import { OfferList } from '~/types/catalog';

@Component({
    components: {
        offer: require('@/components/catalog/offer/').default,
        actionOffer: require('@/components/catalog/action-offer/').default,
        offers: require('@/components/catalog/offer-horisontal-slider/').default,
    },
    computed: mapGetters(['region']),
})
export default class RootActionsCatalogPageComponent extends Vue {

    private top: OfferList = null;
    private sections: OfferList[] = [];
    private metaData = null;

    private head() {
        return {
            title: this.metaData.title,
            meta: [
                { vmid: 'description', name: 'description', content: this.metaData.description }
            ]
        }
    }

    private async asyncData({store}) {
        const data = await store.dispatch('catalog/Actions');

        return {
            top: data.top,
            sections: data.sections,
            metaData: data.meta,
        };
    }

    @watch('region')
    private async onRegionChange() {

        const data = await this.$store.dispatch('catalog/Actions', {
            id: 0,
        });

        this.top = data.top;
        this.sections = data.sections;
        this.metaData = data.meta;
    }
}
